import React from 'react';
import { Link } from 'react-router-dom';

export default () => {
    return (
        <div className="message">
            <h1>Woops!</h1>
            <p>Something went wrong!</p>

            <p>
                <Link to="/">Try again?</Link>
            </p>
        </div>
    );
};
